export enum Social {
  UNSET_SOCIAL = 'UNSET_SOCIAL', // Do not use, needed because of proto3 limitations
  WHATSAPP = 'WHATSAPP',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  INSTAGRAM = 'INSTAGRAM',
  SNAPCHAT = 'SNAPCHAT',
  YOUTUBE = 'YOUTUBE',
  NETFLIX = 'NETFLIX',
  SPOTIFY = 'SPOTIFY',
  DEEZER = 'DEEZER',
  VPN = 'VPN',
}
